import { apiRequest } from '../client';
import { getApiToken } from '../authToken';
import { toJsonSafe } from '../json';

export async function listMySupportTickets({ companyId } = {}) {
  const token = await getApiToken();
  const result = await apiRequest(
    `/api/companies/${encodeURIComponent(companyId)}/support-tickets`,
    { token }
  );
  return result.tickets || [];
}

export async function createSupportTicket({
  companyId,
  clientUser,
  subject,
  category,
  priority,
  message,
  authorType = 'company',
}) {
  const token = await getApiToken();
  const result = await apiRequest(`/api/companies/${encodeURIComponent(companyId)}/support-tickets`, {
    token,
    method: 'POST',
    body: toJsonSafe({
      subject,
      category,
      priority,
      message,
      authorType,
      clientUser,
    }),
  });
  return result.ticket;
}

export async function getSupportTicket({ companyId, ticketId }) {
  const token = await getApiToken();
  try {
    const result = await apiRequest(
      `/api/companies/${encodeURIComponent(companyId)}/support-tickets/${encodeURIComponent(ticketId)}`,
      { token }
    );
    return result.ticket || null;
  } catch (error) {
    if (error?.status === 404) return null;
    throw error;
  }
}

export async function listSupportTicketMessages({ companyId, ticketId }) {
  const token = await getApiToken();
  const result = await apiRequest(
    `/api/companies/${encodeURIComponent(companyId)}/support-tickets/${encodeURIComponent(ticketId)}/messages`,
    { token }
  );
  return result.messages || [];
}

export async function addSupportTicketMessage({
  companyId,
  ticketId,
  clientUser,
  body,
  authorType = 'company',
  attachments = [],
}) {
  const token = await getApiToken();
  const result = await apiRequest(
    `/api/companies/${encodeURIComponent(companyId)}/support-tickets/${encodeURIComponent(ticketId)}/messages`,
    {
      token,
      method: 'POST',
      body: toJsonSafe({
        body,
        authorType,
        clientUser,
        attachments,
      }),
    }
  );
  return result.message;
}

export function subscribeMySupportTickets({ companyId, clientUid, pageSize = 25, onData, onError }) {
  let cancelled = false;
  const load = async () => {
    try {
      const items = await listMySupportTickets({ companyId });
      if (!cancelled) onData(Array.isArray(items) ? items.slice(0, pageSize) : []);
    } catch (err) {
      if (!cancelled && onError) onError(err);
    }
  };
  void load();
  const interval = setInterval(load, 10000);
  return () => {
    cancelled = true;
    clearInterval(interval);
  };
}

export function subscribeSupportTicketMessages({ companyId, ticketId, pageSize = 50, onData, onError }) {
  let cancelled = false;
  const load = async () => {
    try {
      const items = await listSupportTicketMessages({ companyId, ticketId });
      if (!cancelled) onData(Array.isArray(items) ? items.slice(0, pageSize) : []);
    } catch (err) {
      if (!cancelled && onError) onError(err);
    }
  };
  void load();
  const interval = setInterval(load, 6000);
  return () => {
    cancelled = true;
    clearInterval(interval);
  };
}
